module.exports = __webpack_public_path__ + "static/media/reward-completed-check-icon.fc497d43.svg";